import { Row as AntdRow } from "antd"

const Row = props => {
  return <AntdRow {...props} />
}

export default Row
